import PropTypes from 'prop-types';
import { Badge, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { Asterisk } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function ApiMethodDocumentationParameter(_ref) {
  var parameter = _ref.parameter,
      description = _ref.description,
      type = _ref.type,
      defaultValue = _ref.defaultValue,
      isRequired = _ref.isRequired;
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsxs("code", {
        children: [parameter, isRequired && /*#__PURE__*/_jsx(OverlayTrigger, {
          placement: "right",
          overlay: /*#__PURE__*/_jsx(Tooltip, {
            id: "tooltip-api-parameter-required",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "api.required_parameter_tooltip"
            })
          }),
          children: /*#__PURE__*/_jsx(Asterisk, {
            className: "icon ml-2"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("td", {
      children: description
    }), /*#__PURE__*/_jsx("td", {
      children: type
    }), /*#__PURE__*/_jsx("td", {
      children: isRequired ? /*#__PURE__*/_jsx("em", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "api.required_parameter_value"
        })
      }) : /*#__PURE__*/_jsx("code", {
        children: defaultValue
      })
    })]
  });
}

ApiMethodDocumentationParameter.propTypes = {
  parameter: PropTypes.string.isRequired,
  description: PropTypes.any.isRequired,
  type: PropTypes.any.isRequired,
  defaultValue: PropTypes.any,
  isRequired: PropTypes.bool
};
ApiMethodDocumentationParameter.defaultProps = {
  defaultValue: null,
  isRequired: false
};
export function ApiMethodDocumentation(_ref2) {
  var method = _ref2.method,
      type = _ref2.type,
      description = _ref2.description,
      children = _ref2.children,
      exampleUrl = _ref2.exampleUrl,
      exampleResult = _ref2.exampleResult;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mb-2",
      children: [/*#__PURE__*/_jsx(Badge, {
        variant: "primary",
        className: "p-2",
        children: type
      }), ' ', /*#__PURE__*/_jsx("kbd", {
        children: method
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "text-justify mb-2",
      children: description
    }), /*#__PURE__*/_jsxs(Table, {
      responsive: true,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "api.table.header.parameter"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "api.table.header.description"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "api.table.header.value_type"
            })
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              id: "api.table.header.default_value"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: children
      })]
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "api.example_usage"
      })
    }), /*#__PURE__*/_jsx("pre", {
      className: "mt-2",
      children: /*#__PURE__*/_jsxs("code", {
        children: [type, " ", /*#__PURE__*/_jsx("a", {
          href: exampleUrl,
          target: "_blank",
          rel: "noreferrer",
          children: exampleUrl
        }), '\n\n', JSON.stringify(exampleResult, null, 2)]
      })
    })]
  });
}
ApiMethodDocumentation.Parameter = ApiMethodDocumentationParameter;
ApiMethodDocumentation.propTypes = {
  method: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  description: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
  exampleUrl: PropTypes.string.isRequired,
  exampleResult: PropTypes.object.isRequired
};